@if (isVisible()) {
  <div class="syn-splash-screen-container">
    <mat-spinner [diameter]="48"></mat-spinner>
  </div>
}
